/* eslint-disable */
import React from 'react';

import './separator.scss';
import classNames from 'classnames';

export enum SeparatorOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export type SeparatorProps = {
  orientation?: SeparatorOrientation;
};

const Separator: React.FC<SeparatorProps> = ({
  orientation = SeparatorOrientation.Horizontal,
}) => (
  <div
    className={classNames('separator', {
      vertical: orientation === SeparatorOrientation.Vertical,
    })}
  />
);

export default Separator;
